import {createContext} from 'react';

// internal
const RevenueCtx = createContext();

// global
const SystemConfigCtx = createContext({});

export {RevenueCtx, SystemConfigCtx};
